import { unparse } from "papaparse";
import { saveAs } from "file-saver";

export function useCsvExportButtonController<T extends Record<string, any>>(
  data: T[],
  filename = "export.csv"
) {
  const handleExport = () => {
    if (!data || data.length === 0) return;

    const csv = unparse(data);
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    saveAs(blob, filename);
  };

  return {
    handleExport,
  };
}
